import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsInt } from "class-validator";

@Exclude()
export class NumberRange {
  @IsInt()
  @IsDefined()
  @Expose()
  public start: number;

  @IsInt()
  @IsDefined()
  @Expose()
  public end: number;
}
